import { Card } from '@material-ui/core'
import cx from 'clsx'
import { PropsWithChildren } from 'react'

interface QAPanelProps {
  className?: string
  'data-testid'?: string
}

export function QAPanel({
  children,
  className,
  'data-testid': dataTestId,
}: PropsWithChildren<QAPanelProps>) {
  return (
    <Card className={cx('faq-panel', className)} square data-testid={dataTestId}>
      {children}
    </Card>
  )
}
